import type { Habit } from '../api/habits.js';
import { DEFAULT_HABIT_COLOR } from '../lib/palette.js';
import { teinte } from '../lib/teinte.js';
import { cn } from '../lib/cn.js';

/** L'emoji de l'habitude — ou son initiale — dans une `.vignette` du kit, à sa teinte. */
export function HabitGlyph({ habit, small = false }: { habit: Habit; small?: boolean }): React.ReactElement {
  return (
    <span
      className={cn('vignette', small && 'vignette-petite')}
      style={teinte(habit.color ?? DEFAULT_HABIT_COLOR)}
      aria-hidden
    >
      <span>{habit.emoji || habit.name.slice(0, 1).toUpperCase()}</span>
    </span>
  );
}
